import React, { useEffect, useState } from "react";
import Select from "react-select";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, Plus } from "lucide-react";

const OfferPresencial = () => {
  const [carreras, setCarreras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [facultad, setFacultad] = useState({
    value: "todos",
    label: "Toda la oferta",
  });

  useEffect(() => {
    fetch("https://utpl.edu.ec/carreras/services/carreras-pres.json")
      .then((res) => res.json())
      .then((data) => {
        setCarreras(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  }, []);

  const renderHTML = (htmlString) => (
    <span dangerouslySetInnerHTML={{ __html: htmlString }} />
  );

  const optionsFacultad = [
    { value: "todos", label: "Toda la oferta" },
    {
      value: "Ciencias Económicas y Empresariales",
      label: "Ciencias Económicas y Empresariales",
    },
    {
      value: "Ciencias Exactas y Naturales",
      label: "Ciencias Exactas y Naturales",
    },
    {
      value: "Ciencias del Comportamiento",
      label: "Ciencias del Comportamiento",
    },
    { value: "Ciencias de la Salud", label: "Ciencias de la Salud" },
    {
      value: "Ciencias Sociales, Educación y Humanidades",
      label: "Ciencias Sociales, Educación y Humanidades",
    },
    {
      value: "Ciencias Jurídicas y Políticas",
      label: "Ciencias Jurídicas y Políticas",
    },
    {
      value: "Ingenierías y Arquitectura",
      label: "Ingenierías y Arquitectura",
    },
  ];

  const renderTagPresencial = (tag) => {
    if (!tag) return null;

    const styles = {
      "Prueba diagnóstica": "bg-green-100 text-green-700",
      "Prueba de selección": "bg-red-100 text-red-700",
    };

    const label = tag === "Prueba de selección" ? "Prueba de admisión" : tag;

    return (
      <span
        className={`text-xs px-3 py-1 rounded-full font-medium ${styles[tag] || "bg-gray-100 text-gray-700"}`}
      >
        {label}
      </span>
    );
  };

  const carrerasFiltradas =
    facultad.value !== "todos"
      ? carreras.filter((c) =>
          c.field_area.toLowerCase().includes(facultad.value.toLowerCase()),
        )
      : carreras;

  if (loading) {
    return <p className="text-center py-10">Cargando...</p>;
  }

  return (
    <div className="px-16 md:px-10">
      {/* Filtro */}
      <div className="mb-6 max-w-md">
        <p className="mb-2 font-semibold">Facultad</p>
        <Select
          options={optionsFacultad}
          defaultValue={optionsFacultad[0]}
          onChange={setFacultad}
        />
      </div>

      {/* Contador */}
      <div className="mb-6 flex items-center justify-between">
        <p className="text-gray-700">
          Mostrando{" "}
          <span className="font-bold text-gray-900 inline-block min-w-[20px]">
            <AnimatePresence mode="wait">
              <motion.span
                key={carrerasFiltradas.length}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.2 }}
              >
                {carrerasFiltradas.length}
              </motion.span>
            </AnimatePresence>
          </span>{" "}
          {carrerasFiltradas.length === 1 ? "carrera" : "carreras"}
        </p>

        <p className="text-sm text-gray-500">
          {facultad.value === "todos"
            ? "Explora toda la oferta académica"
            : `Resultados en ${facultad.label}`}
        </p>
      </div>

      {/* Grid */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {carrerasFiltradas.map((carrera, index) => (
          <motion.a
            key={index}
            href={carrera.path}
            target="_blank"
            rel="noreferrer"
            initial="rest"
            animate="rest"
            whileHover="hover"
            whileTap="tap"
            className="group relative block bg-white rounded-2xl shadow-md overflow-hidden"
          >
            {/* Imagen */}
            <div className="h-40 overflow-hidden">
              <img
                src={carrera.field_imagen_principal}
                alt={carrera.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
            </div>

            {/* Botón "+" */}
            <motion.div
              variants={{
                rest: { scale: 1, opacity: 0.8 },
                hover: { scale: 1.2, opacity: 1 },
              }}
              transition={{ type: "spring", stiffness: 300 }}
              className="absolute top-4 right-4 bg-white/90 backdrop-blur-md rounded-full p-2 shadow-md"
            >
              <Plus size={12} className="text-gray-800" />
            </motion.div>

            {/* Contenido */}
            <div className="p-5 space-y-3 ">
              
              {renderTagPresencial(carrera.field_tag_presencial)}

              <h3 className="text-base font-bold leading-tight p-0">
                {renderHTML(carrera.title)}
              </h3>

              <p className="text-sm text-gray-600 p-0 leading-none">
                <strong>Facultad:</strong> {carrera.field_area.trim()}
              </p>

              <p className="text-sm text-gray-600 p-0 leading-none">
                <strong>Duración:</strong>{" "}
                {carrera.field_carrera_duracion.trim()}
              </p>
            </div>

            {/* Overlay */}
            <motion.div
              variants={{
                rest: { opacity: 0 },
                hover: { opacity: 1 },
                tap: { opacity: 1 },
              }}
              transition={{ duration: 0.25 }}
              className="absolute inset-0 bg-black/10 flex items-center justify-center"
            >
              <span className="flex items-center gap-2 text-white font-semibold text-lg">
              <ArrowRight size={44} />
              </span>
            </motion.div>
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default OfferPresencial;
